import { render, staticRenderFns } from "./sdkDocking.vue?vue&type=template&id=3fcd879f"
import script from "./sdkDocking.vue?vue&type=script&lang=js"
export * from "./sdkDocking.vue?vue&type=script&lang=js"
import style0 from "./sdkDocking.vue?vue&type=style&index=0&id=3fcd879f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports